import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {
    selectWarehouseInitializationState,
    selectWarehouses, WAREHOUSE_INITIALIZATION_STATE_COMPLETE
} from "../../../../store/reducers/warehouse/warehouseReducer";
import {
    ITEM_INITIALIZATION_STATE_COMPLETE,
    selectItemInitializationState,
    selectItems
} from "../../../../store/reducers/item/itemReducer";
import {selectActiveOrganization} from "../../../../store/reducers/auth/authReducer";
import {useNavigate, useParams} from "react-router-dom";
import EventBus from "../../../../eventbus/EventBus";
import {
    WAREHOUSE_OPERATION_REVISION_ADD_ITEM_SUCCESS,
    WAREHOUSE_OPERATION_REVISION_APPROVED_ITEM_SUCCESS, WAREHOUSE_OPERATION_REVISION_DATE_SUCCESS,
    WAREHOUSE_OPERATION_REVISION_DELETE_ITEM_SUCCESS, WAREHOUSE_OPERATION_REVISION_EMPLOYEE_SUCCESS,
    WAREHOUSE_OPERATION_REVISION_NOTE_SUCCESS,
    WAREHOUSE_OPERATION_REVISION_NUMBER_SUCCESS,
    WAREHOUSE_OPERATION_REVISION_UPDATE_ITEM_SUCCESS
} from "../../../../eventbus/warehouse/revisionEvent";
import SpinnerComponent from "../../../../components/common/SpinnerComponent";
import WarehouseNo from "../../../../components/warehouse/operation/WarehouseNo";
import ItemNo from "../../../../components/warehouse/operation/ItemNo";
import {getRevisionItemAsync} from "../../../../store/reducers/warehouse/revisionReducer";
import EditRevisionForm from "./EditRevisionForm";

const EditRevisions = () => {

    const warehouseInitializationState = useSelector(selectWarehouseInitializationState)
    const itemInitializationState = useSelector(selectItemInitializationState)
    const activeOrganization = useSelector(selectActiveOrganization)
    const warehouses = useSelector(selectWarehouses)
    const [revision, setRevision] = useState(null)
    const navigate = useNavigate()
    const items = useSelector(selectItems)
    const {id} = useParams()



    useEffect(() => {
        const onAddItemHandler = EventBus.on(WAREHOUSE_OPERATION_REVISION_ADD_ITEM_SUCCESS, (id) => {
            loadRevision().then()
        })

        const onUpdateItemHandler = EventBus.on(WAREHOUSE_OPERATION_REVISION_UPDATE_ITEM_SUCCESS, (id) => {
            loadRevision().then()
        })

        const onDeleteItemHandler = EventBus.on(WAREHOUSE_OPERATION_REVISION_DELETE_ITEM_SUCCESS, (id) => {
            loadRevision().then()
        })

        const onApprovedHandler = EventBus.on(WAREHOUSE_OPERATION_REVISION_APPROVED_ITEM_SUCCESS, (id) => {
            navigate(`../revisions/view/${id}`)
        })

        const onNoteHandler = EventBus.on(WAREHOUSE_OPERATION_REVISION_NOTE_SUCCESS, (id) => {
            loadRevision().then()
        })

        const onChangedDateHandler = EventBus.on(WAREHOUSE_OPERATION_REVISION_DATE_SUCCESS, (id) => {
            loadRevision().then()
        })
        const onChangeEmployeeHandler = EventBus.on(WAREHOUSE_OPERATION_REVISION_EMPLOYEE_SUCCESS, (response) => {
            setRevision(response.data, response.data.items.reverse())
        })

        const onChangedNumberHandler = EventBus.on(WAREHOUSE_OPERATION_REVISION_NUMBER_SUCCESS, (id) => {
            loadRevision().then()
        })


        return () => {
            EventBus.remove(WAREHOUSE_OPERATION_REVISION_ADD_ITEM_SUCCESS, onAddItemHandler)
            EventBus.remove(WAREHOUSE_OPERATION_REVISION_UPDATE_ITEM_SUCCESS, onUpdateItemHandler)
            EventBus.remove(WAREHOUSE_OPERATION_REVISION_DELETE_ITEM_SUCCESS, onDeleteItemHandler)
            EventBus.remove(WAREHOUSE_OPERATION_REVISION_APPROVED_ITEM_SUCCESS, onApprovedHandler)
            EventBus.remove(WAREHOUSE_OPERATION_REVISION_NOTE_SUCCESS, onNoteHandler)
            EventBus.remove(WAREHOUSE_OPERATION_REVISION_DATE_SUCCESS, onChangedDateHandler)
            EventBus.remove(WAREHOUSE_OPERATION_REVISION_EMPLOYEE_SUCCESS, onChangeEmployeeHandler)
            EventBus.remove(WAREHOUSE_OPERATION_REVISION_NUMBER_SUCCESS, onChangedNumberHandler)
        }
    }, [])

    useEffect(() => {
        loadRevision().then()
    },[activeOrganization, id])



    const loadRevision = async () => {
        await getRevisionItemAsync({revisionId: id})
            .then((response) => {
                setRevision(response.data, response.data.items.reverse())
            })
            .catch((error) => {
                setRevision(null)
            })
    }



    if (warehouseInitializationState !== WAREHOUSE_INITIALIZATION_STATE_COMPLETE)
        return <SpinnerComponent />

    if (itemInitializationState !== ITEM_INITIALIZATION_STATE_COMPLETE)
        return <SpinnerComponent />


    if (warehouses?.length === 0)
        return (
            <>
                <WarehouseNo/>
            </>
        )

    if (items?.length === 0)
        return (
            <>
                <ItemNo/>
            </>
        )

    if(!revision)
        return (
            <SpinnerComponent />
        )

    return(
        <>
            <EditRevisionForm revision={revision}/>
        </>
    )
};
export default EditRevisions;